import styled from 'styled-components';

const FallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
`;

const ErrorMessage = styled.div`
  font-size: 20px;
  margin-bottom: 50px;
`;

const ReloadButton = styled.button`
  margin-top: 28px;
  padding: 10px 18px;
  color: #fff;
  background: var(--lms-action);
  border-radius: 6px;
  font-family: 'SF Display Bold';
`;

export { FallbackContainer, ErrorMessage, ReloadButton };
